import { UrlResult } from '@services/url/url.service';
import { Observable } from 'rxjs';
export interface IntegrationCardConfig {
	/**
	 * @description connected has 4 states:
	 * - true: connected
	 * - false: not connected
	 * - undefined: loading state
	 * - null: not applicable
	 *
	 * The Observable is necessary to handle the loading state asynchronously, for each card. Otherwise, all cards would not display until they have all resolved for a given INTEGRATION_TYPE.
	 *
	 * @type {Observable<boolean | undefined | null>}
	 *
	 */
	connected$: Observable<boolean | undefined | null>;
	connectButtonText?: string;
	lawyersConnected?: number;
	totalLawyers?: number;
	imageSource: string;
	title?: string;
	description: string;
	href: UrlResult;
}

export enum INTEGRATION_TYPES {
	ElectronicMortgageInstructions = 'Mortgage Processing',
	TitleInsurance = 'Title Insurance',
	PropertyAndWritsSearching = 'Title & Writs Searching',
	IdentityVerification = 'Identity Verification',
	PracticeManagement = 'Practice Management',
	ElectronicSigning = 'Electronic Signing',
}

export enum INTEGRATIONS {
	STEWART_TITLE = 'stewartTitle',
	TREEFORT = 'treefort',
	FCT = 'fct',
	CHICAGO_TITLE = 'chicagoTitle',
	TITLE_PLUS = 'titlePlus',
	LLC = 'llc',
	CLOSER_SYNC = 'sync',
	SIGN_IT = 'signIt',
	LEAP = 'leap',
	TERANET = 'teranet',
}
